import React from "react";
// components
import {

    TabsLayout,
    TabPanelLayout,
} from "../../components";
// import Layout from "../../layout/Layout";

import AssessmentsReports from "./AnalyzeAndReport";
import BatchAssessmentsReports from "./BatchAssessmentReport"
import Layout from "../../layout/Layout";

// import UserAccess from "../user-access/UserAccess";
// import ProjectConfigLayout from "./project-config/ProjectConfigLayout";
// import RCConfigLayout from "./rc-config/RCConfigLayout";
// import QEConfigLayout from "./qe-config/QEConfigLayout";
// import EvalNextConfigConfigLayout from "./evalnext-config/EvalNextConfigLayout";
import { useSelector } from "react-redux";

// =========================================================================================================
const SetupLayout = React.memo((props) => {
    const [value, setValue] = React.useState(0);
    const { data: permissionsData } = useSelector(state => ({ ...state.permissions }));

    const evalNextPermission = React.useMemo(() => {
        return ["Organization.Setup.getSkillCategory", "Organization.Setup.getProficiencyLevel",
            "Organization.Setup.getCompetencyFramework", "Organization.Setup.getCompetencyFrameworkByAccount",
            "Organization.Setup.getCompetencyFrameworkByProject"
        ].some(item => permissionsData?.has(item));
    }, [permissionsData]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const tabsName = [
        {
            name: "Assessments Reports",
            customWidth: "15rem"
        },
        {
            name: "Batch Assessment Reports",
             customWidth: "15rem"
        },

    ].filter(Boolean);

    const tabsData = [
        {
            name: "Assessments",
            components: [{ component: <AssessmentsReports/> }],
        },
        {
            
            components: [{ component: <BatchAssessmentsReports /> }],
        },


    ].filter(Boolean);

    try {
        return (
            <Layout>
            <>

                <TabsLayout
                   
                    backgroundColor=""
                    customWidth="15rem"
                    value={value}
                    handleChange={handleChange}
                    tabNames={tabsName}
                    matchingValue={[0, 1, 2, 3, 4]}
                />
                <TabPanelLayout value={value} index={0} tabsData={tabsData} />
            </>
             </Layout>
        );
    } catch (err) {
        // return <CommonErrorMessage />;
    }
});

export default SetupLayout;
